 import React, { useState, useEffect, useMemo, useRef, forwardRef, useImperativeHandle } from 'react';
 import { createPortal } from 'react-dom';
import angle   from './img/angle.gif';
import shvel   from './img/shvel.gif';
import zigzag  from './img/zigzag.gif';

import angle1  from './img/angle1.gif';
import shvel1  from './img/shvel1.gif';
import zigzag1 from './img/zigzag1.gif';
// картинки угла загиба
import a30   from './img/30.png';
import a60   from './img/60.png';
import a90   from './img/90.png';
import a120  from './img/120.png';
// новые картинки для швеллера и зигзага (зависят от двух углов)
import SH_90_90 from './img/shveller_90_90.png';
import SH_90_60 from './img/shveller_90_60.png';
import SH_60_60 from './img/shveller_60_60.png';
import ZIG_90_90 from './img/Zigzag_90_90.png';
import ZIG_30_60 from './img/Zigzag_30_60.png';
import SH_90_30 from './img/Zigzag_90_30.png';

const angleImgs = { 30: a30, 60: a60, 90: a90, 120: a120 };

const imgsMain = { angle, channel: shvel, zigzag };
const imgsRes  = { angle: angle1, channel: shvel1, zigzag: zigzag1 };
// карты изображений под пары углов
const channelImgs = { '90_90': SH_90_90, '90_60': SH_90_60, '60_60': SH_60_60, '90_30': SH_90_30 };
const zigzagImgs  = { '90_90': ZIG_90_90, '30_60': ZIG_30_60 };
function pickZigzagKey(a, b) {
  const key = `${a}_${b}`;
  return zigzagImgs[key] ? key : '90_90'; // с нашими ограничениями всегда найдётся
}

/* ---------- утилиты (расчёты) ---------- */
// фиксированный K-factor (положение нейтрали). При желании откалибруйте.
const K_CONST = 0.33;
const calcAngle = ({ A, B, S, angleRad }) => {
  const X   = K_CONST;
  const phi = Number.isFinite(angleRad) ? angleRad : Math.PI / 2;
  const L   = A + B - 2 * S + phi * (X * S);
  const a   = A - S + (phi / 2) * (X * S);
  const b   = B - S + (phi / 2) * (X * S);
  const Li  = phi * (X * S);
  const La  = A - S;
  const Lb  = B - S;
  return { L, a, b, Li, La, Lb };
};
const calcChannel = ({ A, B, C, S, angleRad1, angleRad2 }) => {
  const X   = K_CONST;
  const φ1  = Number.isFinite(angleRad1) ? angleRad1 : Math.PI/2;
  const φ2  = Number.isFinite(angleRad2) ? angleRad2 : Math.PI/2;
  const L   = A + B + C - 4*S + (φ1 + φ2) * (X*S);
  const a   = A - S + (φ1/2) * (X*S);
  const b   = B - S + (φ2/2) * (X*S);
  const Li1 = φ1 * (X*S);
  const Li2 = φ2 * (X*S);
  const La  = A - S;
  const Lb  = B - S;
  const Lc  = C - 2*S;               // средняя прямая
  return { L, a, b, Li1, Li2, La, Lb, Lc };
};
const calcZigzag = calcChannel;       // та же топология: 2 гиба и прямая C
const PROFILE_LABELS = { angle:'Уголок', channel:'Швеллер', zigzag:'Зигзаг' };
const LIMITS = {
  S_MIN: 2, S_MAX: 5,     // толщина 2–5 мм
  BEND_MIN: 35,           // мин. загиб стороны
  LEN_MAX: 3000,          // макс. длина детали (мм)
  WIDTH_MAX: 1800,        // макс. L после округления (мм)
};
// какие стороны считаем «полками» для проверки BEND_MIN
const MIN_BEND_FIELDS = {
  angle:['A','B'],
  channel:['A','B'],
  zigzag:['A','B'],
};
// допустимые углы для зигзага
const ZIG_LEFT_OPTS = [90, 30];
const zigRightOpts = (left) => (left === 90 ? [90] : [60]);
const CHANNEL_LEFT_OPTS = [90, 60];
const channelRightOpts = (left) => (left === 90 ? [90, 60, 30] : [60]);

function Modal({ open, onClose, children, actions }) {
  if (!open) return null;
  return createPortal(
    <div onClick={onClose} style={{
      position:'fixed', inset:0, background:'rgba(0,0,0,.45)',
      display:'flex', alignItems:'center', justifyContent:'center', zIndex:5000
    }}>
      <div onClick={e=>e.stopPropagation()} style={{
        background:'#fff', borderRadius:8, padding:22, maxWidth:520, width:'92%',
        fontFamily:'"Exo 2",sans-serif', color:'#2a3486', textAlign:'center'
      }}>
        <div style={{marginBottom:16, fontSize:16, lineHeight:1.4}}>{children}</div>
        <div style={{display:'flex', gap:12, justifyContent:'center'}}>
          {actions || <button className="action-btn" onClick={onClose}>ОК</button>}
        </div>
      </div>
    </div>,
    document.body
  );
}
/* ---------- компонент ---------- */
 const BendCalc = forwardRef(function BendCalc(
  { thickness, sheetLength, sheetHeight, onResult, onAddToCut, computeByApp, mode = 'bend',
    selectedSheets = 1, onSuggestSheets },
  ref
) {
    const hostRef = useRef(null);
  const [shadowRoot, setShadowRoot] = useState(null);
  useEffect(() => {
    if (!hostRef.current || shadowRoot) return;
    const root = hostRef.current.attachShadow({ mode: 'open' });
    setShadowRoot(root);
  }, [shadowRoot]);
  // — чтобы не ругался линтер на неиспользуемый проп
  useEffect(() => {}, [mode]);

  // --- helpers для persistent state ---
  const read = (k, fallback) => {
    try {
      const raw = sessionStorage.getItem(k);
      return raw == null ? fallback : JSON.parse(raw);
    } catch { return fallback; }
  };
  const write = (k, v) => {
    try { sessionStorage.setItem(k, JSON.stringify(v)); } catch {}
  };
  const mounted = useRef(false);

  // ключи хранения
  const K = {
    profile: 'bendcalc_profile',
    equal:   'bendcalc_equal',
    S:       'bendcalc_S',
      angleDeg:'bendcalc_angleDeg',   // для Уголка (один угол)
    angleDeg1:'bendcalc_angleDeg1', // для Швеллера/Зигзага (левый)
    angleDeg2:'bendcalc_angleDeg2', // для Швеллера/Зигзага (правый)
    qty:     'bendcalc_qty',
    partLen: 'bendcalc_partLen',          // ← длина детали
    values:  (p) => `bendcalc_values_${p ?? 'none'}`,
    sheet:   'bendcalc_sheetLen',
    result:  (p) => `bendcalc_result_${p ?? 'none'}`,
    rezCollapsed: (p) => `bendcalc_rezCollapsed_${p ?? 'none'}`, // NEW: свёрнуто/развёрнуто по профилю
  };

  const ALLOWED_PROFILES = ['angle','channel','zigzag'];
const [profile, setProfile] = useState(() => {
  const p = read(K.profile, null);
  return ALLOWED_PROFILES.includes(p) ? p : 'angle';
});
  const [equal, setEqual]       = useState(() => read(K.equal, true));
  const [S, setS]               = useState(() => read(K.S, thickness ?? 1));
const [bendAngle, setBendAngle]   = useState(() => read(K.angleDeg, 90));
const [bendAngle1, setBendAngle1] = useState(() => read(K.angleDeg1, 90));
const [bendAngle2, setBendAngle2] = useState(() => read(K.angleDeg2, 90));
  const [values, setValues]     = useState(() => read(K.values(read(K.profile,null)), {}));
  const [result, setResult]     = useState(() => read(K.result(read(K.profile, null)), null));
  const [rezCollapsed, setRezCollapsed] = useState(() => read(K.rezCollapsed(read(K.profile, null)), true));
  const [qty, setQty]           = useState(() => read(K.qty, 1));
  const [qtyStr, setQtyStr]     = useState(() => String(read(K.qty, 1)));
  const [sheetLen, setSheetLen] = useState(() => read(K.sheet, sheetLength));
  const [partLen, setPartLen]   = useState(() => String(read(K.partLen, '')));
  const [tooBigModal, setTooBigModal] = useState(null);     // текст → показать «заготовка > листа»
 const [needSheets, setNeedSheets]   = useState(null);     // {selected, need}
 const [pendingAdd, setPendingAdd]   = useState(null);     // { width, height, qty, bendMeta }
  // NEW: текстовое состояние для поля "Длина детали"
  const [partLenText, setPartLenText] = useState(() => String(read(K.partLen, '')));
  function buildBendOffsets(profile, res) {
  const L  = res?.L ?? 0;
  const S  = [];                           // последовательность участков вдоль L
  // Подбираем последовательность: прямой → дуга → прямой → ...
  switch (profile) {
    case 'angle':   // 1 гиб
      S.push(res.La, res.Li, res.Lb);
      break;
    case 'channel': // 2 гиба
    case 'zigzag':
      S.push(res.La, (res.Li1 ?? res.Li), res.Lc, (res.Li2 ?? res.Li), res.Lb);
      break;
    default:
      return [];
  }
  // Идём слева направо и кладём линию посередине каждого сегмента-дуги (Li)
  const offsets = [];
  let acc = 0;
  for (let i = 0; i < S.length; i++) {
    const seg = S[i] || 0;
        const isArc =
      (profile === 'angle' && i === 1) ||
      ((profile === 'channel' || profile === 'zigzag') && (i === 1 || i === 3));
    if (isArc) offsets.push(acc + seg / 2);  // середина дуги
    acc += seg;
  }
  // фильтр на адекватность
  return offsets.filter(x => x > 0 && x < (L || Infinity));
}
useEffect(() => {
  if (profile === 'zigzag') {
    // если слева некорректный угол — вернём 90
    if (!ZIG_LEFT_OPTS.includes(bendAngle1)) setBendAngle1(90);
    const allowedR = zigRightOpts(bendAngle1);
        if (!allowedR.includes(bendAngle2)) setBendAngle2(allowedR[0]);
  } else if (profile === 'channel') {
    // NEW:
    if (!CHANNEL_LEFT_OPTS.includes(bendAngle1)) setBendAngle1(90);
    const allowedR = channelRightOpts(bendAngle1);
    if (!allowedR.includes(bendAngle2)) setBendAngle2(allowedR[0]);
  }
}, [profile, bendAngle1, bendAngle2]);
  /* --------- списки значений для выпадающих списков --------- */
  // толщина металла (мм)
  const thicknessValues = [
    0.1,0.2,0.3,0.4,0.5,0.6,0.8,1,1.2,1.3,1.5,1.6,1.8,2,
    2.5,3,3.5,4,4.5,5,5.5,6,8,10,12,14,16,18,20
  ];
  const thicknessOpts = useMemo(() => {
    const set = new Set(thicknessValues);
    if (thickness) set.add(thickness);
    return Array.from(set).sort((a,b)=>a-b);
  }, [thickness]);

  useEffect(() => {
    if (sheetLength && sheetLength !== sheetLen) {
      setSheetLen(sheetLength);
    }
  }, [sheetLength, sheetLen]);

  useEffect(() => {
    if (thickness && thickness !== S) setS(thickness);
  }, [thickness, S]);

  // --- сохраняем всё в sessionStorage при изменениях ---
  useEffect(() => { if (mounted.current) write(K.profile, profile); }, [profile]);
  useEffect(() => { if (mounted.current) write(K.equal,   equal);   }, [equal]);
  useEffect(() => { if (mounted.current) write(K.S,       S);       }, [S]);
    useEffect(() => { if (mounted.current) write(K.angleDeg1, bendAngle1); }, [bendAngle1]);
  useEffect(() => { if (mounted.current) write(K.angleDeg2, bendAngle2); }, [bendAngle2]);
  useEffect(() => { if (mounted.current) write(K.qty,     qty);     }, [qty]);
  useEffect(() => { if (mounted.current) write(K.sheet,   sheetLen);}, [sheetLen]);
  useEffect(() => { if (mounted.current) write(K.partLen, partLen); }, [partLen]);
  useEffect(() => { setPartLenText(String(partLen ?? '')); }, [partLen]);
  useEffect(() => { if (mounted.current) write(K.rezCollapsed(profile), rezCollapsed); }, [rezCollapsed, profile]); // NEW
  useEffect(() => {
    if (mounted.current) write(K.values(profile), values);
  }, [values, profile]);
  useEffect(() => { mounted.current = true; }, []);

  useEffect(() => {
    const clearBendCalcStorage = () => {
      Object.keys(sessionStorage)
        .filter(k => k.startsWith('bendcalc_'))
        .forEach(k => sessionStorage.removeItem(k));
    };

    // Очистка при полной перезагрузке страницы
    window.addEventListener('beforeunload', clearBendCalcStorage);

    return () => {
      window.removeEventListener('beforeunload', clearBendCalcStorage);
    };
  }, []);

  /* ---------- CSS прямо здесь ---------- */
  const baseStyles = `
/* ---------- базовые стили без :root ---------- */

/* общий фон страницы */
body{
  margin:0;
  background:linear-gradient(160deg,#e0e7ff 0%,#fdf2f8 100%);
  min-height:100vh;
  color:rgb(42,52,134);                    /* единый цвет текста */
  font:16px/1.45 "Exo2",sans-serif;        /* шрифт Exo 2 */
  -webkit-font-smoothing:antialiased;
}

/* заголовки */
h1,h2,h3{margin:.3em 0;font-weight:600;color:rgb(42,52,134)}
h1{font-size:1.6rem}
h2{font-size:1.25rem}
h3{font-size:1.3rem}

/* ---------- header ---------- */
header{
  display:flex;align-items:center;justify-content:center;
  padding:0.5rem 2rem;margin:2rem auto 1.5rem;max-width:960px;
  background:#ffffff;                       /* surface */
  border-radius:12px;
  box-shadow:0 8px 20px rgba(0,0,0,.06);
}
header h3{margin-left:.5rem;text-align:center}

/* ---------- контейнеры ---------- */
.containt-row{display:grid;grid-template-columns:3fr 0fr;gap:1.75rem}

/* ---------- меню профилей ---------- */
.menu{
  display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));
  gap:1rem;margin:1.5rem 0 2.5rem;padding:0;list-style:none
}
.menu li{
  position:relative;cursor:pointer;
  padding:.9rem 1.1rem;border-radius:12px;
  background:#f7f9fc;                       /* surface-alt */
  text-align:center;font-weight:600;
  transition:transform .25s cubic-bezier(.4,0,.2,1),box-shadow .25s cubic-bezier(.4,0,.2,1),background .25s cubic-bezier(.4,0,.2,1);
  color: rgb(42,52,134);
}
.menu li:hover{transform:translateY(-2px);box-shadow:0 2px 4px rgba(0,0,0,.05)}
.menu li.active{
  color:#fff;cursor:default;
  background:linear-gradient(135deg, rgb(226, 158, 59), rgb(226, 158, 59));
  box-shadow:0 8px 20px rgba(0,0,0,.06);
}
    .menu-note{
  margin:-0.5rem 0 1.5rem;
  text-align:left;
  font-size:.95rem;
  color:#d32f2f; /* заметный красный */
}

/* ---------- секции формы / результата ---------- */
#dan2,#dan3,#rez{
  background:rgb(245, 247, 250);
  border-radius:12px;
  box-shadow:0 2px 4px rgba(0,0,0,.05);
}

/* --- единый блок параметров: 2 колонки, компактно --- */
#dan2{
  display:grid;
  /* адаптивно: от 1 до N колонок, поля всегда видны */
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px 16px;
  align-items:start;
  padding:1rem 1.25rem;
  margin-bottom:1rem;
}

/* строка на всю ширину (для чекбокса) */
#dan2 .row-full{ grid-column:1 / -1; display:flex; align-items:center; gap:.5rem; }

/* floating-label поля */
.fld{ position:relative; min-height:56px; }          /* ровная высота каждой строки */
.fld input, .fld select{
  width:100%;
  height:46px;
  box-sizing:border-box;
  padding:18px 44px 8px 12px;     /* место под метку и суффикс */
  border:1px solid #e9eef6;
  border-radius:10px;
  background:#fff;
  font:inherit;
  line-height:1.2;
  transition:border-color .2s, box-shadow .2s;
}
.fld input:focus, .fld select:focus{
  outline:none; border-color:#667eea; box-shadow:0 0 0 3px #eef1ff;
}
.fld .flabel{
  position:absolute; left:12px; top:6px;
  font-size:12px; line-height:1; color:#5b6bb0; pointer-events:none;
}
.fld .unit{
  position:absolute; right:12px; top:50%; transform:translateY(-50%);
  font-size:12px; font-weight:600; color:#5b6bb0; opacity:.8; pointer-events:none;
}

/* disabled */
.fld input:disabled, .fld select:disabled{
  background:#e9eef6; color:rgb(42,52,134); cursor:not-allowed;
}

/* чекбокс */
#dan2 .check{ display:inline-flex; align-items:center; gap:.5rem; font-weight:600; }
#dan2 input[type="checkbox"]{ width:18px; height:18px; accent-color:#e19e3a; }

/* --- форма параметров профиля --- */
#dan3{
  padding:1.5rem 1.75rem;
  display:flex;                 /* общий контейнер секции */
  flex-direction:column;
  align-items:stretch;
  gap:1.25rem;
}
#dan3 img{width:200px;max-width:100%;height:auto;border-radius:8px;background:#e9eef6}

/* ---------- поля ввода ---------- */
    :root{ --labelH: 34px; }
.field {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}
.field .labelRow{
  display:flex;
  align-items:center;
  justify-content:space-between;
  height:var(--labelH);     /* фиксируем высоту шапки */
  margin-bottom:.35rem;
}
.field .labelRow > label{ margin:0; }   /* чтоб label внутри шапки не тянул высоту */
.field > label{
  display:flex;
  align-items:center;
  height:var(--labelH);     /* такая же высота для полей без labelRow */
  margin-bottom:.35rem;
}
 .equalToggle{
  display:inline-flex;align-items:center;gap:.35rem;
  height:calc(var(--labelH) - 6px);      /* тумблер точно помещается в шапку */
  padding:0 .55rem;                      /* без вертикальных паддингов */
  border:1px solid #e0e7ff;border-radius:999px;
   background:#fff;font-size:.85rem;white-space:nowrap;font-weight:600;color:#2a3486;
 }
.equalToggle input{width:14px;height:14px;margin:0;accent-color:#e19e3a}
.field label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #2a3486; /* основной цвет текста */
  margin-bottom: 0.35rem;
}

.field input,
.field select {
  padding: 0.65rem 0.9rem;
  font-size: 1rem;
  border: 1px solid #d0d7eb;
  border-radius: 10px;
  background: #fff;
  color: #2a3486;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
}
/* два селекта в одну строку для двухугольных профилей */
.field .split2{ display:flex; gap:8px; }
.field .split2 select{ flex:1; }

.field input::placeholder {
  color: #9aa2c6;
  opacity: 0.7;
}

.field input:focus,
.field select:focus {
  outline: none;
  border-color: #667eea;            /* фиолетовый акцент */
  box-shadow: 0 0 0 3px rgba(102,126,234,0.25);
  background: #fdfdff;
}

/* disabled */
.field input:disabled,
.field select:disabled {
  background: #eef1f9;
  cursor: not-allowed;
  color: #7a84b7;
}



/* чекбокс */
.dan label{display:inline-flex;align-items:center;gap:.45rem;font-weight:600}
.dan input[type="checkbox"]{width:18px;height:18px;accent-color:#e19e3a;cursor:pointer}

/* ---------- кнопка ---------- */
.button{
  display:inline-block;margin-top:1rem;padding:.65rem 1.7rem;
  font-weight:600;color:#fff;cursor:pointer;border:none;border-radius:999px;
  background:linear-gradient(135deg, rgb(226, 158, 59), rgb(226, 158, 59));
  box-shadow:0 8px 20px rgba(0,0,0,.06);
  transition:transform .15s cubic-bezier(.34,1.56,.64,1),box-shadow .25s cubic-bezier(.4,0,.2,1);
}
.button:hover{transform:translateY(-2px);box-shadow:0 10px 24px rgba(102,126,234,.25)}
.button:active{transform:translateY(0);box-shadow:0 2px 4px rgba(0,0,0,.05)}
.button:disabled{opacity:.6;cursor:not-allowed}

/* ---------- результат ---------- */
#rez{
  position:relative;margin-top:2rem;padding:2rem 2.25rem 2.5rem 2rem;
  background:#ecfdf5;                      /* success-bg */
  box-shadow:0 8px 20px rgba(0,0,0,.06);
  overflow:hidden;
}
    #rez .actions{margin-top:1rem;display:flex;gap:.5rem;flex-wrap:wrap}
.button.secondary{
  background:#e9eef6;
  color:rgb(42,52,134);
  box-shadow:0 2px 4px rgba(0,0,0,.05);
}
.button.secondary:hover{transform:translateY(-2px)}
#rez::before{
  content:"";position:absolute;left:0;top:0;bottom:0;width:6px;
  background:#10b981;                      /* success */
  border-top-left-radius:inherit;border-bottom-left-radius:inherit;
}
#rez h2{margin-top:0;margin-bottom:1.25rem;color:#10b981}
#rez img{
  float:right;width:200px;max-width:45%;height:auto;margin-left:1.25rem;border-radius:8px;
  filter:drop-shadow(0 4px 8px rgba(0,0,0,.1))
}
#rez .dan>div{margin-bottom:.45rem;font-variant-numeric:tabular-nums}

/* ---------- NEW: кнопка сворачивания результата ---------- */
#rez .rez-toggle{
  position:absolute;top:10px;right:10px;
  width:32px;height:32px;border-radius:50%;
  border:1px solid #d0d7eb;background:#ffffff;
  display:inline-flex;align-items:center;justify-content:center;
  cursor:pointer;
  font-weight:700;font-size:18px;line-height:1;
  box-shadow:0 1px 2px rgba(0,0,0,.04);
}
#rez .rez-toggle:hover{transform:translateY(-1px);box-shadow:0 4px 10px rgba(0,0,0,.08)}
#rez .rez-toggle:focus-visible{outline:2px solid #667eea;outline-offset:2px}
#rez h2{padding-right:48px} /* запас справа под кнопку */

/* когда свёрнуто — скрываем контент, оставляем только заголовок и кнопку */
#rez[data-collapsed="1"]{padding-bottom:1rem}
#rez[data-collapsed="1"] #rez-content{display:none}

/* ---------- изображения профилей ---------- */
.leftimg{filter:drop-shadow(0 4px 10px rgba(0,0,0,.08));border-radius:8px}

/* ---------- анимации ---------- */
@keyframes fadeIn{0%{opacity:0;transform:translateY(12px)}100%{opacity:1;transform:none}}

/* ---------- подсказка ---------- */
.hint{
  margin:0 0 1.5rem;
  padding:1rem 1.25rem;
  font-size:.95rem;line-height:1.55;color:rgb(42,52,134);
  background:#f7f9fc;
  border:1px dashed #e0e7ff;
  border-radius:12px;
}
.hint em{font-style:italic}  
/* ---------- карточка-формула ---------- */
.formula{
  display:none;
  margin:0 0 1.75rem;
  padding:1rem 1.25rem;
  font-size:.95rem;line-height:1.55;color:rgb(42,52,134);
  background:#ffffff;
  border-left:4px solid #e19e3a;
  border-radius:12px;
  box-shadow:0 2px 4px rgba(0,0,0,.04);
}
.formula strong{display:block;margin-bottom:.5rem}
.formula sub{vertical-align:sub;font-size:.75em}

.dan-with-img{
  display:grid;
  grid-template-columns: minmax(200px,240px) 1fr;
  gap:1.25rem;
  align-items:flex-start;
}
.dan-with-img .imgcol{
  display:flex;
  justify-content:center;
}
.dan-with-img .leftimg{
  width:100%;
  max-width:240px;
  height:auto;
  background:#e9eef6;
  border-radius:8px;
  filter:drop-shadow(0 4px 10px rgba(0,0,0,.08));
}
.dan-with-img .formcol{min-width:0}
.mini-result {
  margin-top: 1rem;
  padding: 0.85rem 1rem;
  background: #f7f9fc;
  border: 1px solid #e0e7ff;
  border-radius: 10px;
  font-size: 0.95rem;
  color: #2a3486;
  line-height: 1.4;
  box-shadow: 0 2px 4px rgba(0,0,0,.05);
}
.mini-result div {
  margin-bottom: 0.35rem;
}
.mini-result div:last-child {
  margin-bottom: 0;
}

@media (max-width:720px){
  .dan-with-img{grid-template-columns:1fr}
  .dan-with-img .imgcol{justify-content:center}
    #dan2{ grid-template-columns:1fr; }
}


/* ---------- адаптив ---------- */
@media(max-width:720px){
  .menu{grid-template-columns:1fr 1fr}
  #dan3{flex-direction:column;align-items:center;text-align:center}
  header{flex-direction:column}
  .containt-row{grid-template-columns:1fr}
}
`;

  const reset = () => {
    setValues({});
    setResult(null);
    setEqual(true);
    setQty(1);
    setRezCollapsed(true);  // по умолчанию свёрнуто
    // сразу сохраняем «пустое» состояние для текущего профиля
    write(K.values(profile), {});
  };

  const clearResult = () => {
    setResult(null);
    try { sessionStorage.removeItem(K.result(profile)); } catch {}
    if (typeof onResult === 'function') onResult(null, '', '');
  };

const req = {
  angle  : equal ? ['A']     : ['A','B'],
  channel: equal ? ['A','C'] : ['A','B','C'],
  zigzag : ['A','B','C'],
}[profile] || [];


  const labels = {A:'Полка A',B:'Полка B',C:'Высота C',D:'Полка D',E:'Полка E'};

  // ---- форматирование результата ----
  const formatResultText = (profile, res) => {
    const lines = [
      'Результат',
      'result',
      `L : ${res.L.toFixed(3)} мм`,
      res.a != null ? `a : ${res.a.toFixed(3)} мм` : null,
      res.b != null ? `b : ${res.b.toFixed(3)} мм` : null,
      res.d != null ? `d : ${res.d.toFixed(3)} мм` : null,
      res.e != null ? `e : ${res.e.toFixed(3)} мм` : null,
      res.Li != null ? `Li : ${res.Li.toFixed(3)} мм` : null,
      res.La != null ? `La : ${res.La.toFixed(3)} мм` : null,
      res.Lb != null ? `Lb : ${res.Lb.toFixed(3)} мм` : null,
      res.Lc != null ? `Lc : ${res.Lc.toFixed(3)} мм` : null,
      res.Ld != null ? `Ld : ${res.Ld.toFixed(3)} мм` : null,
      res.Le != null ? `Le : ${res.Le.toFixed(3)} мм` : null,
    ].filter(Boolean);
    return lines.join('\\n');
  };

  const formatBendLine = (profile, res) => {
    if (!res) return '';
    const f = (v) => Number(v).toFixed(3);
    const title = PROFILE_LABELS[profile] ?? profile ?? '';
        const parts = [
      `Загиб листа (${title})`,
     `L : ${f(res.L)} мм`,
      res.a != null ? `a : ${f(res.a)} мм` : null,
      res.b != null ? `b : ${f(res.b)} мм` : null,
      res.Li1 != null ? `Li1 : ${f(res.Li1)} мм` : (res.Li != null ? `Li : ${f(res.Li)} мм` : null),
      res.Li2 != null ? `Li2 : ${f(res.Li2)} мм` : null,
      res.La != null ? `La : ${f(res.La)} мм` : null,
      res.Lc != null ? `Lc : ${f(res.Lc)} мм` : null,
      res.Lb != null ? `Lb : ${f(res.Lb)} мм` : null,
    ].filter(Boolean);
    return parts.join('; ');
  };

  // ---- Вспомогательная очистка чисел ----
 const sanitize = (s = "") =>
   s.replace(',', '.')
    .replace(/[^\d.]/g, '')
    .replace(/^(\d*\.\d*).*$/, '$1'); // максимум одна точка
     const reLen = /^\d*([.,]\d*)?$/;

  // ---- Стабильные обработчики для #dan2 ----
  const handleFieldChange = React.useCallback((e) => {
    const key = e.target.id;           // 'A' | 'B' | 'C' | 'D' | 'E'
    const val = e.target.value;
    setValues(prev => (prev[key] === val ? prev : { ...prev, [key]: val }));
  }, []);

  const handleFieldBlur = React.useCallback((e) => {
    const key = e.target.id;
    const v = sanitize(e.target.value);
    setValues(prev => {
      if (v === '' || isNaN(parseFloat(v))) {
        return prev; // не затираем, если пусто
      }
      return prev[key] === v ? prev : { ...prev, [key]: v };
    });
  }, []);

  const handleSChange = React.useCallback((e) => {
    const val = parseFloat(e.target.value);
    setS(prev => (prev === val ? prev : val));
  }, []);

  const handleEqualChange = React.useCallback((e) => {
    setEqual(e.target.checked);
  }, []);

  const handleQtyChange = React.useCallback((e) => {
    setQtyStr(e.target.value.replace(/\\D/g, ''));
  }, []);

  const handleQtyBlur = React.useCallback(() => {
    const qNum = Math.max(1, parseInt((qtyStr || '1'), 10));
    setQty(qNum);
    setQtyStr(String(qNum));
  }, [qtyStr]);


  const calc = (opts = {}) => {
    if (req.some(f => !values[f])) { alert('Вы ввели не все значения!'); return; }
    // считаем геометрию и L
    const num = v => parseFloat(v);
    const data = {
      ...Object.fromEntries(Object.entries(values).map(([k,v]) => [k, num(v)])),
      S: num(S),
        ...(profile === 'angle'
        ? { angleRad:  (bendAngle  * Math.PI) / 180 }
        : { angleRad1: (bendAngle1 * Math.PI) / 180,
            angleRad2: (bendAngle2 * Math.PI) / 180 })
    };
    if (profile === 'angle'   && equal) data.B = data.A;
    if (profile === 'channel' && equal) data.B = data.A;  // равнополочный швеллер: A = B
     if (data.S < LIMITS.S_MIN || data.S > LIMITS.S_MAX) {
   setTooBigModal(`Гибка доступна для толщин от ${LIMITS.S_MIN} до ${LIMITS.S_MAX} мм. Выбрано S=${data.S} мм.`);
   setRezCollapsed(true);
   return null;
 }
 // минимальный загиб стороны (полок)
 const toCheck = MIN_BEND_FIELDS[profile] || [];
 const tooSmall = toCheck.filter(k => data[k] != null && data[k] < LIMITS.BEND_MIN);
 if (tooSmall.length) {
   setTooBigModal(`Минимальная ширина загиба — от ${LIMITS.BEND_MIN} мм. Полки ${tooSmall.join(', ')} меньше ${LIMITS.BEND_MIN} мм.`);
   setRezCollapsed(true);
   return null;
 }

const res = ({
  angle  : calcAngle,
  channel: calcChannel,
  zigzag : calcZigzag
})[profile]?.(data);

    if (!res || Object.values(res).some(v => v <= 0)) { alert('Так не бывает!'); return; }

    // прямоугольник для раскроя = (Длина детали) × (L)
    const rawLen = String(partLen || '').trim();
    const cleanedLen = sanitize(rawLen);
    const rectW = parseFloat(cleanedLen);
    if (!rectW || rectW <= 0) { alert('Введите длину детали'); return; }
            const ROUND_STEP_MM = 10; // ← если нужно 400 из 395, ставим 10; для 1100 из 1090 — 100
    const ceilTo = (v, step = ROUND_STEP_MM) => Math.ceil((+v + 1e-9) / step) * step;
    const rectH_raw = res.L;
    const rectH = ceilTo(rectH_raw);
    const Wsheet = parseFloat(sheetLen);
    const Hsheet = parseFloat(sheetHeight || '0');
    const QTY    = parseFloat(qty);
     if (rectW > LIMITS.LEN_MAX) {
   const outEarly = { ...res, perSheet:0, sheets:0 };
   setTooBigModal(`Максимальная длина детали для гибки — ${LIMITS.LEN_MAX/1000} м. У вас ${rectW} мм.`);
   setResult(outEarly); write(K.result(profile), outEarly); setRezCollapsed(true);
         return {
        ...outEarly, rectW, rectH, rotated:false, qty:QTY, profile,
        bendMeta:{
          type:'bend', profile,
          profileLabel: PROFILE_LABELS[profile],
          dims:{ A:data.A, B:data.B, C:data.C, D:data.D, E:data.E },
          partLen: rectW,
          angles: (profile==='angle' ? [bendAngle] : [bendAngle1, bendAngle2]),
          L:res.L, L_rounded:rectH,
          bendOffsets: buildBendOffsets(profile,res),
        }
      };

 }
 if (rectH > LIMITS.WIDTH_MAX) {
   const outEarly = { ...res, perSheet:0, sheets:0 };
   setTooBigModal(`Максимальная ширина заготовки (L) — ${LIMITS.WIDTH_MAX} мм. Сейчас L ≈ ${rectH} мм.`);
   setResult(outEarly); write(K.result(profile), outEarly); setRezCollapsed(true);
         return {
        ...outEarly, rectW, rectH, rotated:false, qty:QTY, profile,
        bendMeta:{
          type:'bend', profile,
          profileLabel: PROFILE_LABELS[profile],
          dims:{ A:data.A, B:data.B, C:data.C, D:data.D, E:data.E },
          partLen: rectW,
          angles: (profile==='angle' ? [bendAngle] : [bendAngle1, bendAngle2]),
          L:res.L, L_rounded:rectH,
          bendOffsets: buildBendOffsets(profile,res),
        }
      };
 }
       // 0) заготовка > выбранного листа (ни в одной ориентации не помещается)
   const fits1 = rectW <= Wsheet && rectH <= Hsheet;
   const fits2 = rectH <= Wsheet && rectW <= Hsheet;
   if (!fits1 && !fits2) {
     setTooBigModal(
       `Заготовка для гибки (${rectW}×${rectH} мм) больше выбранного листа `
       + `(${Wsheet}×${Hsheet} мм). Измените параметры профиля/длину детали или `
       + `выберите другой лист.`
     );
     const outEarly = { ...res, perSheet:0, sheets:0 };
     setResult(outEarly);
     write(K.result(profile), outEarly);
     setRezCollapsed(true);
          return {
       ...outEarly, rectW, rectH, rotated:false, qty:QTY, profile,
       bendMeta:{
         type:'bend', profile,
         profileLabel: PROFILE_LABELS[profile],
         dims:{ A:data.A, B:data.B, C:data.C, D:data.D, E:data.E },
         partLen: rectW,
         angles: (profile==='angle' ? [bendAngle] : [bendAngle1, bendAngle2]),
         L:res.L, L_rounded:rectH,
         bendOffsets: buildBendOffsets(profile,res),
       }
     };
    }
    const bendMeta = {
      type:'bend', profile,
      profileLabel: PROFILE_LABELS[profile],
      dims:{ A:data.A, B:data.B, C:data.C, D:data.D, E:data.E },
      partLen: rectW,
      angles: (profile==='angle' ? [bendAngle] : [bendAngle1, bendAngle2]),
      L: res.L, L_rounded: rectH,
      bendOffsets: buildBendOffsets(profile, res),
    };
   
    let perSheet = 0, sheets = 0, rotated = false;

    if (Wsheet > 0 && Hsheet > 0 && rectW > 0 && rectH > 0) {
      // Пробуем две ориентации и берём ту, что даёт меньше листов; при равенстве — где больше на лист
      const useApp = typeof computeByApp === 'function';
      if (useApp) {
        const s1 = computeByApp(rectW, rectH, QTY);
        const s2 = computeByApp(rectH, rectW, QTY);
        const pick = (a, b) =>
          (a.sheets < b.sheets) ? a :
          (a.sheets > b.sheets) ? b :
          (a.perSheet >= b.perSheet ? a : b);
        const best = pick(s1, s2);
        perSheet = best.perSheet;
        sheets   = best.sheets;
        rotated  = (best === s2);
      } else {
        const fit1  = Math.floor(Wsheet / rectW) * Math.floor(Hsheet / rectH);
        const fit2  = Math.floor(Wsheet / rectH) * Math.floor(Hsheet / rectW);
        rotated     = fit2 > fit1;
        perSheet    = Math.max(fit1, fit2);
        sheets      = perSheet > 0 && QTY > 0 ? Math.ceil(QTY / perSheet) : 0;
      }
    }

    const out = { ...res, perSheet, sheets };
    setResult(out);
    setRezCollapsed(true);  // держим результат свёрнутым после расчёта
    write(K.result(profile), out);
    write(K.rezCollapsed(profile), true);
  const sel = Number(selectedSheets) || 0;
  const fractionalSel = sel > 0 && sel < 1;      // выбрана доля листа (0.xx)
  const wholeSel      = Math.floor(sel);         // целая часть «выбранных» листов
  let shouldAsk = false;
  if (perSheet > 0 && QTY > 0) {
    const need = Math.ceil(QTY / Math.max(1, perSheet));
    // спрашиваем ДОБАВИТЬ листы только если пользователь выбрал ЦЕЛЫЕ листы
    shouldAsk = !fractionalSel && wholeSel >= 1 && need > wholeSel;
    if (shouldAsk) setNeedSheets({ selected: wholeSel, need });
  }

    const textMultiline = formatResultText(profile, out);
    const textOneLine   = formatBendLine(profile, out);
    if (typeof onResult === 'function') onResult(out, textMultiline, textOneLine);

 if (typeof onAddToCut === 'function' && perSheet > 0 && QTY > 0 && !opts.silent) {
   const w = rotated ? rectH : rectW;     // L-сторона – уже округлённая
   const h = rotated ? rectW : rectH;
   const payload = { width: w, height: h, qty: QTY, bendMeta };
   if (shouldAsk) {
     // ждём подтверждения в модалке
     setPendingAdd(payload);
   } else {
     onAddToCut(payload);
   }
 }
    return { ...out, rectW, rectH, rotated, qty: QTY, profile, bendMeta };
  };

  const toggleRez = () => {
    setRezCollapsed(prev => {
      const next = !prev;
      write(K.rezCollapsed(profile), next);
      return next;
    });
  };

  useImperativeHandle(ref, () => ({ calc }));
  return (
    <>
      <div ref={hostRef} />
      {shadowRoot && createPortal(
        <>
          {/* Стили и весь UI внутри Shadow DOM */}
          <style>{baseStyles}</style>
          <div className="containt">
        <div className="containt-row">
          <main>
            {/* ___ Меню профилей _____ */}
            <ul className="menu">
  {[
    ['angle','Уголок'],
    ['channel','Швеллер'],
    ['zigzag','Зигзаг'],
  ].map(([key,label]) => (
                <li
                  key={key}
                  className={profile === key ? 'active' : ''}
                  onClick={() => {
                    if (profile !== key) {
                      // перед переключением — сохраняем текущие values
                      write(K.values(profile), values);
                      // загружаем значения для нового профиля, если были
                      const saved = read(K.values(key), {});
                      const savedRes = read(K.result(key), null);
                      const savedCollapsed = read(K.rezCollapsed(key), true);
                      setValues(saved);
                      setResult(savedRes);
                      setProfile(key);
                      setEqual(true);
                      setQty(1);
                      setQtyStr('1');
                      setRezCollapsed(savedCollapsed);
                    }
                  }}
                >
                  {label}
                </li>
              ))}
            </ul>
            <p className="menu-note">* Загиб деталей по индивидуальным размерам можно оформить в офисе</p>
            {profile && (
              <>
                <h2>{{angle:'Уголок',channel:'Швеллер',zigzag:'Зигзаг'}[profile]}</h2>

                <p className="hint">
                  Введите значения: толщины&nbsp;материала&nbsp;<strong>S</strong> и величин&nbsp;A, B, C, D, E.<br/>
                  Затем укажите <strong>Длину детали</strong> (прямой заготовки), выберите <strong>угол загиба</strong> и задайте <strong>Количество</strong>.
                </p>

                {/* объединённый блок параметров */}
                <div id="dan3">
                  <div className="dan dan-with-img">
                    {/* левая колонка — картинка */}
                    <div className="imgcol">
                    {profile === 'angle' ? (
                      <img
                        src={angleImgs[bendAngle] || angleImgs[90]}
                        alt={`${bendAngle}°`}
                        className="leftimg"
                      />
                    ) : profile === 'channel' ? (
                      <img
                        src={channelImgs[`${Math.max(bendAngle1,bendAngle2)}_${Math.min(bendAngle1,bendAngle2)}`] || imgsMain[profile]}
                        alt={`Швеллер ${bendAngle1}°/${bendAngle2}°`}
                        className="leftimg"
                      />
                    ) : (
                        <img
    src={zigzagImgs[pickZigzagKey(bendAngle1, bendAngle2)] || imgsMain[profile]}
    alt={`Зигзаг ${bendAngle1}°/${bendAngle2}°`}
    className="leftimg"
  />
                    )}
                    </div>

                    {/* правая колонка — единый блок параметров */}
                    <div className="formcol">
                      <div id="dan2">
                        {/* Толщина */}
                        <div className="field">
                          <label htmlFor="fld-s">Толщина S (мм)</label>
                          <select id="fld-s" value={S} onChange={handleSChange} disabled>
                            {thicknessOpts.map(v => (
                              <option key={v} value={v}>{v}</option>
                            ))}
                          </select>
                        </div>

                        {/* Длина листа */}
                        <div className="field">
                          <label htmlFor="fld-sheet">Длина листа (мм)</label>
                          <input id="fld-sheet" type="number" value={sheetLen} disabled />
                        </div>

                        {/* Ширина листа */}
                        <div className="field">
                          <label htmlFor="fld-sheet-h">Ширина листа (мм)</label>
                          <input id="fld-sheet-h" type="number" value={sheetHeight || ''} disabled />
                        </div>

                        {/* Угол(ы) загиба */}
                        <div className="field">
                          <label>Угол загиба (°)</label>
                          {profile === 'angle' ? (
                            <select
                              id="fld-angle"
                              value={bendAngle}
                              onChange={e => setBendAngle(parseInt(e.target.value, 10))}
                            >
                              {[30, 60, 90, 120].map(a => (
                                <option key={a} value={a}>{a}°</option>
                              ))}
                            </select>
                          ) : (
<div className="split2">
  <select
    id="fld-angle1"
    value={bendAngle1}
    onChange={e => setBendAngle1(parseInt(e.target.value, 10))}
  >
    {(profile === 'channel' ? CHANNEL_LEFT_OPTS : ZIG_LEFT_OPTS).map(a => (
      <option key={a} value={a}>{a}°</option>
    ))}
  </select>
  <select
    id="fld-angle2"
    value={bendAngle2}
    onChange={e => setBendAngle2(parseInt(e.target.value, 10))}
  >
    {(profile === 'channel' ? channelRightOpts(bendAngle1) : zigRightOpts(bendAngle1)).map(a => (
      <option key={a} value={a}>{a}°</option>
    ))}
  </select>
</div>
                          )}
                        </div>

{/* Поле A с компактным тумблером равнополочности */}
{req.includes('A') && (
  <div className="field" key="A">
    <div className="labelRow">
      <label htmlFor="A">Полка A (мм)</label>
      {(profile==='angle'||profile==='channel') && (
        <label className="equalToggle" title="Равнополочный">
          <input type="checkbox" checked={equal} onChange={handleEqualChange}/>
          {'A = B'}
        </label>
      )}
    </div>
    <input
      id="A"
      type="number"
      value={values.A ?? ''}
      onChange={handleFieldChange}
      onBlur={handleFieldBlur}
    />
  </div>
)}

{/* Остальные поля */}
{(['B','C','D','E'].filter(n => req.includes(n))).map(n => (
  <div className="field" key={n}>
    <label htmlFor={n}>{({A:'Полка A',B:'Полка B',C:'Высота C',D:'Полка D',E:'Полка E'})[n]} (мм)</label>
    <input
      id={n}
      type="number"
      value={values[n] ?? ''}
      onChange={handleFieldChange}
      onBlur={handleFieldBlur}
    />
  </div>
))}


{/* Длина детали */}
                        <div className="field">
  <div className="labelRow">
    <label htmlFor="fld-part">Длина детали (мм)</label>
  </div>
                          <input
                            id="fld-part"
                            type="text"
                            inputMode="decimal"
                            value={partLenText}
                            onChange={(e) => {
                              const next = e.target.value;
                              // разрешаем промежуточный ввод (например "1000.")
                              if (/^\d*([.,]\d*)?$/.test(next)) {
                                setPartLenText(next);
                              }
                            }}
                            onBlur={() => {
                              const cleaned = sanitize(partLenText);
                              if (cleaned === '') {
                                // если очистили всё — показываем последнее сохранённое
                                setPartLenText(String(partLen || ''));
                              } else {
                                setPartLen(cleaned);
                                setPartLenText(cleaned);
                                write(K.partLen, cleaned);
                              }
                            }}
                          />
                        </div>

                        {/* Количество деталей */}
                        <div className="field">
                          <label htmlFor="fld-qty">Количество деталей (шт)</label>
                          <input
                            id="fld-qty"
                            type="number"
                            value={qtyStr}
                            onChange={handleQtyChange}
                            onBlur={handleQtyBlur}
                          />
                        </div>

                        {result && (
                          <div className="mini-result">
                            {result.perSheet ? <div>Деталей на лист: <strong>{result.perSheet}</strong></div> : null}
                            {result.sheets ? <div>Листов нужно: <strong>{result.sheets}</strong></div> : null}
                          </div>
                        )}
                      </div>

                      <button type="button" className="button" onClick={calc}>Рассчитать</button>
                    </div>
                  </div>
                </div>

                {/* результат — ВСЕГДА виден при выбранном профиле */}
                <div
                  id="rez"
                  data-collapsed={rezCollapsed ? '1' : '0'}
                  role="region"
                  aria-labelledby="rez-title"
                >
                  <button
                    type="button"
                    className="rez-toggle"
                    onClick={toggleRez}
                    aria-expanded={!rezCollapsed}
                    aria-controls="rez-content"
                    aria-label={rezCollapsed ? 'Развернуть результат' : 'Свернуть результат'}
                  >
                    <span aria-hidden="true">{rezCollapsed ? '+' : '−'}</span>
                  </button>

                  <h2 id="rez-title">Результат</h2>

                  <div id="rez-content">
                    {result ? (
                      <>
                        <img src={imgsRes[profile]} alt="result" className="leftimg" />
                        <div className="dan">
                          {Object.entries(result).map(([k,v]) => {
                            if (k==='perSheet' || k==='sheets') return null;
                            return <div key={k}>{k} : {v.toFixed(3)} мм</div>;
                          })}
                        </div>
                      </>
                    ) : (
                      <div className="dan">
                        <div>Здесь появится расчёт после нажатия «Рассчитать».</div>
                      </div>
                    )}

                    <div className="actions">
                      <button
                        type="button"
                        className="button secondary"
                        onClick={clearResult}
                        disabled={!result}
                      >
                        Сбросить результат
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </main>
        </div>
      </div>
        </>
      , shadowRoot)}

      <Modal open={!!tooBigModal} onClose={() => setTooBigModal(null)}>
  {tooBigModal}
</Modal>

<Modal
  open={!!needSheets}
  onClose={() => setNeedSheets(null)}
  actions={
    <>
  <button className="action-btn" onClick={() => {
    if (onSuggestSheets && needSheets?.need) {
      onSuggestSheets(needSheets.need);       // сначала просим добавить листы
    }
    if (pendingAdd) {
      // затем — добавляем детали (после обновления стейтов у родителя)
      setTimeout(() => { onAddToCut?.(pendingAdd); setPendingAdd(null); }, 0);
    }
    setNeedSheets(null);
  }}>Да, добавить</button>
      <button className="action-btn" onClick={() => setNeedSheets(null)}>Нет</button>
    </>
  }
>
  {needSheets && (
    <>
      Ваши детали не входят на <b>{needSheets.selected}</b> выбранных листов.<br />
      Потребуется: <b>{needSheets.need}</b> лист(а). Добавить листы для выбранного количества деталей?
    </>
  )}
</Modal>

    </>
  );
});

export default React.memo(BendCalc);
